// extracted by mini-css-extract-plugin
export var container = "_5z-1";
export var editor = "_5z-2";
export var resizable = "_5z-3";
export var wrapper = "_5z-0";